module.exports = __webpack_public_path__ + "img/storefront_idea_large.5ef50f0e.png";